var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKpiTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 46.3H3.7V16.2c0-1-.8-2-1.8-2s-1.9 1-1.9 2v32c0 1 .8 1.8 1.9 1.8h49.3c1 0 1.8-.8 1.8-1.8s-.8-2-1.8-2zM1.9 10c1 0 1.8-.9 1.8-2V2C3.7.9 3 0 2 0S0 .8 0 1.9V8C0 9 .8 10 1.9 10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40.7c1 0 1.9-.8 1.9-1.9V28.2c0-1-.9-1.9-1.9-1.9-1 0-1.9.9-1.9 1.9v10.6c0 1 .9 2 1.9 2zM21.7 40.7c1 0 1.9-.8 1.9-1.9v-22c0-1-.9-1.8-1.9-1.8-1 0-1.9.8-1.9 1.8v22c0 1 .9 2 1.9 2zM32.4 40.7c1 0 1.9-.8 1.9-1.9V22c0-1-.8-1.8-1.9-1.8-1 0-1.8.8-1.8 1.8v16.8c0 1 .8 2 1.8 2zM43 40.7c1.1 0 2-.8 2-1.9V11.2c0-1-.9-1.9-2-1.9-1 0-1.8.8-1.8 1.9v27.6c0 1 .8 2 1.9 2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiTracking);
export default __webpack_public_path__ + "static/media/kpi-tracking.8209d86a.svg";
export { ForwardRef as ReactComponent };